import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ExternalRoutingGuardService, RoutingGuardService } from 'sp-arch-lib';
import { InsolventMerchantGuardService } from 'sp-mark/local-guards/insolvent-merchant-guard.service';
import { SingleUnitsGuardService } from 'sp-mark/local-guards/single-units-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/boot',
    pathMatch: 'full'
  },
  {
    path: '',
    children: [
      {
        path: 'boot',
        loadChildren: () => import('sp-mark/feature-modules/boot/boot.module').then(m => m.BootModule),
        data: { skipCheckMerchant: true }
      },
      {
        path: 'dashboard',
        loadChildren: () => import('sp-mark/feature-modules/dashboard/dashboard.module').then(m => m.DashbooardModule)
      },
      {
        path: 'notifications',
        loadChildren: () => import('sp-mark/feature-modules/notifications/notifications.module').then(m => m.NotificationsModule),
      
      },
      {
        path: 'sell',
        loadChildren: () => import('sp-mark/feature-modules/sell/sell.module').then(m => m.SellModule),
      },
      {
        path: 'customers',
        loadChildren: () => import('sp-mark/feature-modules/customers/customers.module').then(m => m.CustomersModule)
      },
      {
        path: 'receipts',
        loadChildren: () => import('sp-mark/feature-modules/receipts/receipts.module').then(m => m.ReceiptsModule)
      },
      {
        path: 'self-purchases',
        loadChildren: () => import('sp-mark/feature-modules/self-purchases/self-purchases.module').then(m => m.SelfPurchasesModule),
        canActivate: [SingleUnitsGuardService]
      },
      {
        path: 'products-catalog',
        loadChildren: () => import('sp-mark/feature-modules/products-catalog/products-catalog.module').then(m => m.ProductsCatalogModule),
        canActivate: [SingleUnitsGuardService]
      },
      {
        path: 'registry',
        loadChildren: () => import('sp-mark/feature-modules/registry/registry.module').then(m => m.RegistryModule)
      },
      {
        path: 'local-units',
        loadChildren: () => import('sp-mark/feature-modules/local-units/local-units.module').then(m => m.LocalUnitsModule)
      },
      {
        path: 'users',
        loadChildren: () => import('sp-mark/feature-modules/users/users.module').then(m => m.UsersModule)
      },
      {
        path: 'statistics',
        loadChildren: () => import('sp-mark/feature-modules/statistics/statistics.module').then(m => m.StatisticsModule)
      },
      {
        path: 'integration',
        loadChildren: () => import('sp-mark/feature-modules/integration/integration.module').then(m => m.IntegrationModule)
      },
      {
        path: 'payments',
        loadChildren: () => import('sp-mark/feature-modules/payments/payments.module').then(m => m.PaymentsModule)
      },
      {
        path: 'services',
        loadChildren: () => import('sp-mark/feature-modules/services/services.module').then(m => m.ServicesModule)
      },
      {
        path: 'gateways',
        loadChildren: () => import('sp-mark/feature-modules/gateways/gateways.module').then(m => m.GatewaysModule)
      },
      {
        path: 'request-support',
        loadChildren: () => import('sp-mark/feature-modules/request-support/request-support.module').then(m => m.RequestSupportModule)
      },
      {
        path: 'manage-user',
        loadChildren: () => import('sp-mark/feature-modules/manage-user/manage-user.module').then(m => m.ManageUserModule)
      }
    ],
    canActivateChild: [RoutingGuardService, InsolventMerchantGuardService]
  },
  {
    path: '',
    children: [
      {
        path: 'login',
        loadChildren: () => import('sp-mark/feature-modules/login/login.module').then(m => m.LoginModule)
      },
      {
        path: 'welcome',
        loadChildren: () => import('sp-mark/feature-modules/welcome/sp-welcome.module').then(m => m.SpWelcomeModule)
      },
      {
        path: 'sell-preview',
        loadChildren: () =>
          import('sp-mark/feature-modules/sell-preview-public/sell-preview-public.module').then(m => m.SellPreviewPublicModule)
      },
      {
        path: 'conclude-sell',
        loadChildren: () =>
          import('sp-mark/feature-modules/conclude-selling-public/conclude-selling-public.module').then(m => m.ConcludeSellingPublicModule)
      },
      {
        path: 'successfull-payment',
        loadChildren: () => import('sp-mark/feature-modules/payment-congrats/payment-congrats.module').then(m => m.PaymentCongratsModule)
      },
      {
        path: 'payment-ko',
        loadChildren: () => import('sp-mark/feature-modules/payment-ko/payment-ko.module').then(m => m.PaymentKoModule)
      },
      {
        path: 'redirect-message',
        loadChildren: () => import('sp-mark/feature-modules/redirect-message/redirect-message.module').then(m => m.RedirectMessageModule)
      },
      {
        path: 'operation-in-progress',
        loadChildren: () =>
          import('sp-mark/feature-modules/operation-in-progress/operation-in-progress.module').then(m => m.OperationInProgressModule)
      }
    ],
    canActivateChild: [ExternalRoutingGuardService]
  }
];

export const publicRoutes = routes
  .find(x => x.canActivateChild && x.canActivateChild.includes(ExternalRoutingGuardService))
  .children.map(x => x.path);

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
